/** Red asterisk appended to a required field's label. `aria-hidden` because
 *  the required state is conveyed to assistive tech by the input's own
 *  required semantics, not this decorative glyph. The leading margin keeps it
 *  off the last word of the label.
 *
 *  Its own module rather than a FieldRenderer export: FieldRenderer imports
 *  RepeatableRowControl, so a value import back the other way would close a
 *  cycle. Both label surfaces need the same glyph — the repeatable table's
 *  column header and cell labels printed a plain `' *'` and so were the one
 *  place in the renderer where "required" was grey. */
export function RequiredMark() {
  return (
    <span aria-hidden style={{ color: '#dc2626', marginLeft: 2 }}>
      *
    </span>
  );
}
